import {DialogContent, Stack, Typography} from "@mui/material";
import MainBg from '../../assets/main-bg.png'
import {useIsMobileHook} from "../../utils";
import XDLoadoutLogo from "../../components/XDLoadoutLogo";
import AttachmentsSummary from "./AttachmentsSummary";
import LoadoutDisplayMenu from "./LoadoutDisplayMenu";
import FeaturedLoadouts from "../featured/FeaturedLoadouts";
import {WeaponImage} from "../../components/WeaponImage";

function LoadoutDisplay({weapon, attachments, type}) {

    const isMobile = useIsMobileHook();
    const featured = type === 'featured';

    return (
        <DialogContent sx={{
            p: 0,
            backgroundImage: `url(${MainBg})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minWidth: '40vw',
            maxHeight: '100%',
            backgroundColor: '#2e3136',
            width: '100%',
            height: '100%',
            overflowX: 'clip',
            overflowY: 'scroll',
            '&::-webkit-scrollbar': {display: 'none'}
        }}>
            <Stack alignItems='center' sx={{p: {xs: '10px', md: featured ? '30px 30px 0 30px' : '30px'}}}>
                <Stack direction={isMobile ? 'column' : 'row'} alignItems={isMobile ? 'center' : null} sx={{pb: '10px', alignItems: {xs: 'center', md: 'baseline'}}}>
                    { isMobile && featured ? null :
                    <XDLoadoutLogo height='43px'
                                   style={{padding: isMobile ? '5px 15px 10px 15px' : '0 60px 0 0'}}/>
                    }
                    <Typography variant={isMobile ? 'h4' : 'h3'} fontStyle='oblique' fontWeight='bold'
                                sx={{color: 'white'}}>{weapon.name}</Typography>
                </Stack>
                <WeaponImage weapon={weapon.name} isMobile={isMobile} style={{
                    height: isMobile ? 'auto' : '200px',
                    width: isMobile ? '100%' : 'auto',
                    padding: '0 30px 15px 30px'
                }}/>
                {featured ? <FeaturedLoadouts weapon={weapon}/> : <AttachmentsSummary attachments={attachments}/>}
                {type == null ? <LoadoutDisplayMenu weapon={weapon} attachments={attachments}/> : null}
            </Stack>
        </DialogContent>
    )
}

export default LoadoutDisplay